module.exports = __webpack_public_path__ + "img/Functional_Area.27498f31.png";